<div>
  @switch (type()) { @case ('info') {
  <av-icon name="info" size="sm"></av-icon>
  } @case ('danger') {
  <av-icon name="close-round" size="sm"></av-icon>
  } @case ('warning') {
  <av-icon name="alert" size="sm"></av-icon>
  } @case ('success') {
  <av-icon name="tick-round" size="sm"></av-icon>
  } }
</div>
<ng-content></ng-content>
